import { useState, useEffect, useCallback } from 'react';

export default function useSessionStorage(key) {
  const [value, setValue] = useState(
    typeof window !== 'undefined' ? sessionStorage.getItem(key) : undefined,
  );

  const onStorageEvent = useCallback(
    event => {
      if (event.storageArea === sessionStorage && event.key === key) {
        setValue(event.newValue);
      }
    },
    [key],
  );
  useEffect(() => {
    // Set value and cause rerender if key changed
    setValue(sessionStorage.getItem(key));

    // Add listener for current key if a storage event is emitted
    // This will keep session values in sync with the current value if they are updated
    //
    // Note: We have to send manual event since by default storage events
    // aren't dispatched to the same window
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/storage_event
    window.addEventListener('storage', onStorageEvent);
    return () => window.removeEventListener('storage', onStorageEvent);
  }, [key, onStorageEvent]);

  return value;
}
